import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollColorBar from "./components/ScrollColorBar";
import ScrollToTop from "./components/ScrollToTop";
import PrintingUnitedPopup from "./components/PrintingUnitedPopup";
import { AuthProvider } from "./context/AuthContext";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Contact from "./pages/Contact";
import TestimonialsPage from "./pages/TestimonialsPage";
import PrintFactoryPage from "./pages/PrintFactoryPage";
import ImpoProofPage from "./pages/ImpoProofPage";
import BarbieriPage from "./pages/BarbieriPage";
import NixPage from "./pages/NixPage";
import PreviewConcept1 from "./pages/PreviewConcept1";
import PreviewConcept2 from "./pages/PreviewConcept2";
import PreviewConcept3 from "./pages/PreviewConcept3";
import BlogIndex from "./pages/BlogIndex";
import BlogArticle from "./pages/BlogArticle";
import AboutUs from "./pages/AboutUs";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminTestimonials from "./pages/admin/AdminTestimonials";
import AdminBlog from "./pages/admin/AdminBlog";
import AdminLeads from "./pages/admin/AdminLeads";
import AdminContacts from "./pages/admin/AdminContacts";
import ProtectedRoute from "./pages/admin/ProtectedRoute";

const PublicChrome = ({ children }) => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <ScrollColorBar />}
      {!isAdmin && <Navbar />}
      {!isAdmin && <PrintingUnitedPopup />}
      {children}
      {!isAdmin && <Footer />}
    </>
  );
};

function App() {
  return (
    <div className="App min-h-screen bg-white">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <PublicChrome>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/shop/:id" element={<ProductDetail />} />
              <Route path="/printfactory" element={<PrintFactoryPage />} />
              <Route path="/impoproof" element={<ImpoProofPage />} />
              <Route path="/barbieri" element={<BarbieriPage />} />
              <Route path="/nix" element={<NixPage />} />
              <Route path="/preview/concept-1" element={<PreviewConcept1 />} />
              <Route path="/preview/concept-2" element={<PreviewConcept2 />} />
              <Route path="/preview/concept-3" element={<PreviewConcept3 />} />
              <Route path="/blog" element={<BlogIndex />} />
              <Route path="/blog/:slug" element={<BlogArticle />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/testimonials" element={<TestimonialsPage />} />

              {/* Admin */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}
              >
                <Route index element={<AdminProducts />} />
                <Route path="products" element={<AdminProducts />} />
                <Route path="testimonials" element={<AdminTestimonials />} />
                <Route path="blog" element={<AdminBlog />} />
                <Route path="leads" element={<AdminLeads />} />
                <Route path="contacts" element={<AdminContacts />} />
              </Route>
            </Routes>
          </PublicChrome>
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
